import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';

function Sidenav({ userName, userImage, route }) {

    const [active, setActive] = useState('');
    const [mainArr, setMainArr] = useState([]);
    const [loading, setLoading] = useState(true);


    const fetchdata = async () => {

        const { data } = await axios.get(
            `${process.env.REACT_APP_BACKLINK}/api/public`, { withCredentials: true }
        );
        // making data ready for sidenav deisgn
        let modified;
        let arr1 = [];

        modified = data.filteredMainRoutes.filter(item => (item.method !== 'put'))

        modified.map((item, index) => {
            if (item.slug === route) {
                setActive(item.categoryName)
            }
            let unique = `a${index}b`
            let obj = {
                id: unique,
                category: '',
                routes: []
            };
            obj.category = item.categoryName
            modified.forEach(i => {
                if (item.categoryName === i.categoryName) {
                    obj.routes.push({ slug: i.slug, displayName: i.displayName });
                }

            });
            arr1.push(obj);
            return modified

        })
        const categories = arr1.map(o => o.category)
        const filtered = arr1.filter(({ category }, index) => !categories.includes(category, index + 1))
        setMainArr(filtered);
        setLoading(false)
    }
    useEffect(() => {
        fetchdata();
    })

    return (
        <>

            {loading && <h1>Loading...</h1>}
            {/* <!-- Main Sidebar Container --> */}
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                {/* <!-- Brand Logo --> */}
                <Link to={"/"} className="brand-link">

                    <img src="/dist/img/AdminLTELogo.png" alt="AdminLTE Logo" className="brand-image img-circle elevation-3" style={{ opacity: ".8" }} />
                    <span className="brand-text font-weight-light">user[CRUD]</span>
                </Link>

                {/* <!-- Sidebar --> */}
                <div className="sidebar">
                    {/* <!-- Sidebar user panel (optional) --> */}
                    <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                        <div className="image">
                            <img src={`/uploads/${userImage}`} className="img-circle elevation-2" alt="User Profile" />
                        </div>
                        <div className="info">
                            <Link to={`/profile`} className="d-block">{userName}</Link>
                        </div>
                    </div>

                    {/* <!-- Sidebar Menu --> */}
                    <nav className="mt-2">

                        <ul className="list-unstyled ps-0" >

                            {mainArr.map((item) => (
                                <li className="mb-1 " key={item.category}>
                                    <button
                                        className={
                                            `btn btn-toggle ${active === item.category ? 'route-active' : ''} align-items-center rounded category`
                                        }
                                        data-bs-toggle="collapse" data-bs-target={`#${item.id}-collapse`} aria-expanded="false">
                                        {item.category}
                                    </button>
                                    <div
                                        className={
                                            `collapse link-container ${active === item.category ? 'show' : ''}`}
                                        id={`${item.id}-collapse`}
                                    >
                                        <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">

                                            {item.routes.map(single => (
                                                <li key={single.slug} className={`${single.slug === route ? 'route-active' : ''} mb-2`}>
                                                    <Link to={single.slug} className="ml-3">{single.displayName}</Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>))}
                        </ul>

                    </nav>
                    {/* <!-- /.sidebar-menu --> */}
                </div>
                {/* <!-- /.sidebar --> */}
            </aside>
        </>

    )
}

export default Sidenav
